@if(isMobileNav){ @if (isMobileNavOpen) {
<aside class="left-sidebar open">
  <div class="scroll-sidebar">
    <nav class="sidebar-nav">
      <ul id="sidebarnav">
        @for (nav of nav_list; track $index) {
        <ng-container
          *ngIf="
            nav?.always ||
            hasNavClaim(nav?.claimType) ||
            nav?.isDirector == helpers.isDirector()
          "
        >
          <li
            (click)="toogleMobileMenu()"
            class="sidebar-item"
            [routerLink]="[nav?.url]"
            routerLinkActive="active"
          >
            <a
              class="sidebar-link waves-effect waves-dark sidebar-link"
              aria-expanded="true"
            >
              <div class="left-sd">
                <i [class]="nav?.icon"></i>
                <span class="hide-menu">{{ nav?.label }}</span>
              </div>
            </a>
          </li>
        </ng-container>
        }
      </ul>

      <a (click)="toogleMobileMenu()" class="pointer">
        <div class="previous-link">
          <i [class]="isNavOpen ? 'fa fa-angle-left' : 'fa fa-angle-right'"></i>
        </div>
      </a>
    </nav>
  </div>
</aside>
} } @else{
<aside class="left-sidebar" [class]="isNavOpen ? 'open' : 'close'">
  <a class="navbar-brand" [class]="isNavOpen ? 'open' : 'close'">
    @if(isMobileNav){
    <button
      [class]="isMobileNavOpen ? 'mobile-nav-margin' : ''"
      mat-icon-button
      (click)="toogleMobileMenu()"
    >
      <mat-icon>{{ isMobileNavOpen ? "close" : "menu" }}</mat-icon>
    </button>
    } @else { @if (isNavOpen) {

    <span class="logo-wrap" routerLink="/">
      <img
        src="assets/images/sft-travel-desk.svg"
        alt="homepage"
        class="light-logo"
      />
    </span>
    } @if (!isNavOpen) {
    <div class="w-100 text-center py-3 px-1">
      <button (click)="toogleNav()" mat-icon-button>
        <i class="icon-menu-expand text-light"></i>
      </button>
    </div>
    } }
  </a>
  <div class="scroll-sidebar">
    <nav class="sidebar-nav">
      <ul id="sidebarnav">
        @for (nav of nav_list; track $index) {
        <ng-container
          *ngIf="
            nav?.always ||
            hasNavClaim(nav?.claimType) ||
            nav?.isDirector == helpers.isDirector()
          "
        >
          <ng-container
            *ngIf="
              nav?.label === 'Expenses' &&
                (helpers.role_id() === Global.ROLE.ACCOUNTS ||
                  claimTypes.includes('EXP_APPROVE_ACCOUNT_EXPENSE'));
              else continueBlock
            "
          >
            <li
              [matTooltip]="nav?.label"
              [matTooltipDisabled]="isNavOpen"
              (click)="toogleMobileMenu()"
              class="sidebar-item"
              [routerLink]="[nav?.url]"
              routerLinkActive="active"
            >
              <a
                class="sidebar-link waves-effect waves-dark sidebar-link"
                aria-expanded="true"
              >
                <div class="left-sd">
                  <i [class]="nav?.icon"></i>
                  <span class="hide-menu">{{
                    claimTypes.includes('EXP_APPROVE_RM_EXPENSE') ||
                    claimTypes.includes('EXP_VIEW_RM_EXPENSE_LIST')
                      ? 'Expenses'
                      : 'My Expense'
                  }}</span>
                </div>
              </a>
            </li>
            <li
              [matTooltip]="nav?.label"
              [matTooltipDisabled]="isNavOpen"
              (click)="toogleMobileMenu()"
              class="sidebar-item"
              [routerLink]="['/expense-request']"
              routerLinkActive="active"
            >
              <a
                class="sidebar-link waves-effect waves-dark sidebar-link"
                aria-expanded="true"
              >
                <div class="left-sd">
                  <i class="icon-expense"></i>
                  <span class="hide-menu">Expense Approval</span>
                </div>
              </a>
            </li>
          </ng-container>
          <ng-template #continueBlock>
            <li
              [matTooltip]="nav?.label"
              [matTooltipDisabled]="isNavOpen"
              (click)="toogleMobileMenu()"
              class="sidebar-item"
              [routerLink]="[nav?.url]"
              routerLinkActive="active"
            >
              <a
                class="sidebar-link waves-effect waves-dark sidebar-link"
                aria-expanded="true"
              >
                <div class="left-sd">
                  <i [class]="nav?.icon"></i>
                  <span class="hide-menu">{{ nav?.label }}</span>
                </div>
                <!-- @if (isNavOpen) {
                <i
                  class="fa fa-chevron-right"
                  aria-hidden="true"
                  data-aos="fade-right"
                ></i>
                } -->
              </a>
            </li>
          </ng-template>
        </ng-container>
        }
      </ul>

      <!-- <a (click)="toogleNav()" href="javascript:void(0)">
        <div class="previous-link">
          <i [class]="isNavOpen ? 'fa fa-angle-left' : 'fa fa-angle-right'"></i>
        </div>
      </a> -->
    </nav>
  </div>
  <span class="copyright-txt">Powered by : <a href="https://shyamfuture.com/" target="_blank">Shyam Future Tech</a></span>
</aside>
}
